import {
	always,
	and,
	complement,
	compose,
	ifElse,
	isEmpty,
	isNil,
	mapObjIndexed,
	or,
	pickAll,
	values,
} from 'ramda';

export const exists = compose((v) => {
	const isNotEmpty = complement(isEmpty);
	const isNotNil = complement(isNil);
	return and(isNotEmpty(v), isNotNil(v));
});

export const doesNotExist = compose((v) => {
	return or(isEmpty(v), isNil(v));
});

export const getValuesFromData = (
	dataConstants: Record<string, string>,
	data: Record<string, unknown>
): Record<string, any> => {
	return mapObjIndexed((value) => {
		const defaultValue = ifElse(exists, always(value), always(''))(value);
		return defaultValue;
	})(pickAll(values(dataConstants))(data));
};
